var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9745 0H3.02546C1.35459 0 0 1.35459 0 3.02546V24.9745C0 26.6454 1.35459 28 3.02546 28H24.9745C26.6454 28 28 26.6454 28 24.9745V3.02546C28 1.35459 26.6454 0 24.9745 0ZM17.8593 23.7445L12.6561 16.172L6.14174 23.7445H4.45809L11.9086 15.0844L4.45809 4.24108H10.1407L15.0677 11.4118L21.2364 4.24108H22.9201L15.8155 12.4996H15.8151L23.5419 23.7445H17.8593Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.5b7fefb0243c535ac496237698a0c22a.svg";
export { ForwardRef as ReactComponent };